/**
 * 
 */

export const getScholarshipQuotas = (state) => state.scholarshipQuotas;
export const getDeallocatedScholarshipQuotas = (state) => state.scholarshipQuotas.filter(e => e.active === true && e.allocated === false);
